import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({ display }) => {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        width: "30px",
        height: "30px",
        margin: "auto",
        display: display ? display : "block",
        transition: "all 0.5s !important",
      }}
    >
      <span className="sr-only">Loading...</span>
    </Spinner>
  );
};

export default Loader;
